import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Stock } from 'src/app/domain/models/PalletStock';

@Component({
  selector: 'app-stocks-table',
  templateUrl: './stocks-table.component.html',
  styleUrls: ['./stocks-table.component.css']
})
export class StocksTableComponent {
  @Input() stocks: Stock[] = [];
  @Input() loading: boolean = false;
  @Input() pageSize: number = 5;
  @Input() totalCount: number = 0;

  @Output() lazyLoad = new EventEmitter<any>();
  @Output() viewStock = new EventEmitter<Stock>();
  @Output() viewRules = new EventEmitter<Stock>();
  @Output() viewAlert = new EventEmitter<number>();
  @Output() configureQuarter = new EventEmitter<Stock>();
  @Output() createProgram = new EventEmitter<Stock>();

  constructor(public translate: TranslateService) { }

  onLazyLoad(event: any): void {
    this.lazyLoad.emit(event);
  }

  onViewStock(stock: Stock): void {
    this.viewStock.emit(stock);
  }

  onViewRules(stock: Stock): void {
    this.viewRules.emit(stock);
  }

  onShowStockAlert(stockId: number): void {
    this.viewAlert.emit(stockId);
  }

  onShowQuarterConfig(stock: Stock): void {
    this.configureQuarter.emit(stock);
  }

  onShowProgramFromStock(stock: Stock): void {
    this.createProgram.emit(stock);
  }
}
